'use strict';

var Js_exn = require("bs-platform/lib/js/js_exn.js");

var make = (function(message) { return new Error(message); });

var $$throw = (function(message) { throw new Error(message); });

function unsafeFromExn(exn) {
  var makeUnknownJsExn = (function(exn) { return new Error("Unexpected error: " + exn); });
  if (exn.RE_EXN_ID === Js_exn.$$Error) {
    return exn._1;
  } else {
    return makeUnknownJsExn(exn);
  }
}

exports.make = make;
exports.$$throw = $$throw;
exports.unsafeFromExn = unsafeFromExn;
/* No side effect */
